import { noop } from 'ui-components/default-props/noop';

import { NotesSectionHeaderContent } from './notes-section-header-content';
import FulfillmentPlanNotes from '../../../../fulfillment-plans/notes';
import { OrdersSidebarSection } from '../orders-sidebar-section';
import sectionStyle from '../orders-sidebar-section.module.less';

/**
 * @param {object} props
 * @param {boolean} [props.open]
 * @param {(isExpanded: boolean) => void} [props.onClick]
 * @param {object[]} props.notes
 * @param {string} props.fulfillmentPlanId
 * @param {object} [props.dragHandleProps]
 * @returns {JSX.Element}
 */
export const NotesSection = ({ open = false, onClick = noop, notes, fulfillmentPlanId, dragHandleProps }) => {
  const headerContent = <NotesSectionHeaderContent notes={notes} />;

  const sectionContent = (
    <FulfillmentPlanNotes
      containerClassName={sectionStyle['order-sidebar-section-default-padding']}
      fulfillmentPlanId={fulfillmentPlanId}
    />
  );

  const collapsedSectionContent = (
    <FulfillmentPlanNotes
      containerClassName={sectionStyle['order-sidebar-section-default-padding']}
      fulfillmentPlanId={fulfillmentPlanId}
      hideUnpinned
    />
  );

  return (
    <OrdersSidebarSection
      collapsedSectionContent={collapsedSectionContent}
      dragHandleProps={dragHandleProps}
      headerContent={headerContent}
      isExpanded={open}
      sectionContent={sectionContent}
      toggleIsExpanded={onClick}
    />
  );
};
